import { selectSelected } from '@common-modules/mediaDetails';
import {
  ClusterSegment,
  ClusterItem,
} from '@common-modules/mediaDetails/models';
import { FILTER_PARAMETER_TYPE } from '@helpers/constants';
import { NonEmptyArray } from 'ts-essentials';

export const getActiveState = (
  segments: Readonly<NonEmptyArray<ClusterSegment>>,
  selected: ReturnType<typeof selectSelected>
): 1 | 0 | -1 => {
  // 1 = all segments selected, 0 = some segments selected, -1 none selected
  const selectedItems = segments.filter((segment) => selected[segment.id]);
  return selectedItems.length === 0
    ? -1
    : selectedItems.length === segments.length
      ? 1
      : 0;
};

export const filterClusterList = (
  clusterList: ReadonlyArray<ClusterItem>,
  filterList: FILTER_PARAMETER_TYPE[]
) => {
  if (filterList.length === 0) {
    return [];
  }
  // if (filterList.includes('manualInterp')) {
  //   return clusterList.reduce<ClusterItem[]>((acc, cur) => {
  //     const tmp: ElementOf<ClusterItem['segments']>[] = [];
  //     cur.segments.forEach((item) => {
  //       if (item.isManualInterpolation) {
  //         tmp.push(item);
  //       }
  //     });
  //     if (arrayHasContents(tmp)) {
  //       acc.push({ ...cur, segments: tmp });
  //     }
  //     return acc;
  //   }, []);
  // } else {
  return clusterList.filter((clusterItem) => {
    if (clusterItem.type === 'vehicle') {
      return filterList.includes('licensePlate');
    }
    return filterList.includes(clusterItem.type as FILTER_PARAMETER_TYPE);
  });
};
